import { BoundingSphere, Cartesian3, Cartographic, HeadingPitchRange, JulianDate, Math } from 'cesium';

export const zoomToEntityBound = (entity, duration = 1, zoomOffset = true) => {
    const height = 4000

    let entityPosition; const zoomPoint = {}
    if (entity.position) {

        viewer.trackedEntity = entity

        const currentTime = viewer.clock.currentTime

        //check if time is moving
        const animateStatus = viewer.clock.shouldAnimate;
        if (animateStatus) {
            const clockSpeed = viewer.clock.multiplier * duration
            const newTime = JulianDate.addSeconds(currentTime, clockSpeed, new JulianDate())
            entityPosition = entity.position.getValue(newTime)
        } else {
            entityPosition = entity.position.getValue(currentTime)
        }

        if (entityPosition) {
            entityPosition = Cartographic.fromCartesian(entityPosition)
            zoomPoint.lon = Math.toDegrees(entityPosition.longitude)
            zoomPoint.lat = Math.toDegrees(entityPosition.latitude)
            zoomPoint.height = entityPosition.height

            // const height = viewer.camera.positionCartographic.height
            const camera = viewer.camera
            const boundingSphere = new BoundingSphere(Cartesian3.fromDegrees(zoomPoint.lon, zoomPoint.lat, zoomPoint.height), height)
            const zoomParams = {
                duration: duration,
            }
            if (zoomOffset)
                zoomParams.offset = new HeadingPitchRange(camera.heading, camera.pitch, height)
                
            camera.flyToBoundingSphere(boundingSphere, zoomParams)
        }
    }
}

/*
Get loaded datasource by id
*/
export const getDataSource = (fileId, colorFile, data) => {

    let dataSourceName = fileId;
    if (colorFile == fileId || data.length == 1) {
        dataSourceName += "_colored"
    }

    let dataSource = viewer.dataSources.getByName(dataSourceName)
    if (dataSource.length == 1) {
        return dataSource[0]
    }

    return null;
}

export function findColoredDataSource() {
    const count = viewer.dataSources.length;
    for (let i = 0; i < count; i++) {
        const dataSource = viewer.dataSources.get(i);
        const name = dataSource.name
        if (name.includes('_colored')) {
            return dataSource
        }
    }
    return null;
}